module.exports = __webpack_public_path__ + "img/logo-culture-diagnostics-colour.002d5946.png";